import { ShieldAlert, Search, BadgeCheck, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ScanPrompt() {
  const { t } = useTranslation();

  return (
    <div className="py-28 md:py-36 flex flex-col items-center justify-center text-center">
      <div className="container px-6 md:px-16 max-w-7xl">
        
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-snug mx-auto max-w-[90%] sm:max-w-[80%] md:max-w-[65%]">
          {t('scan_prompt.title', '¿Qué saben los hackers sobre ti?')}
        </h2>
        
        <p className="text-lg md:text-xl text-gray-300 mt-6 mx-auto max-w-3xl leading-relaxed">
          {t(
            'scan_prompt.description',
            'Tu información podría estar expuesta y siendo vendida en la Dark Web. Compruébalo ahora con un escaneo gratuito.'
          )}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-14 py-14">
          <div className="flex flex-col items-center gap-4">
            <Search className="h-16 w-16 text-green-400" />
            <h3 className="text-xl font-semibold text-white">
              {t('scan_prompt.real_time_scan')}
            </h3>
            <p className="text-gray-400 text-lg max-w-xs">
              {t(
                'scan_prompt.real_time_scan_desc'
              )}
            </p>
          </div>

          <div className="flex flex-col items-center gap-4">
            <ShieldAlert className="h-16 w-16 text-red-500" />
            <h3 className="text-xl font-semibold text-white">
              {t('scan_prompt.security_risks')}
            </h3>
            <p className="text-gray-400 text-lg max-w-xs">
              {t(
                'scan_prompt.security_risks_desc'
              )}
            </p>
          </div>

          <div className="flex flex-col items-center gap-4">
            <BadgeCheck className="h-16 w-16 text-yellow-400" />
            <h3 className="text-xl font-semibold text-white">
              {t('scan_prompt.free_scan')}
            </h3>
            <p className="text-gray-400 text-lg max-w-xs">
              {t(
                'scan_prompt.free_scan_desc'
              )}
            </p>
          </div>
        </div>

        <Link
          to="/scan"
          className="inline-flex items-center justify-center px-12 py-5 bg-red-600 text-white text-xl font-semibold rounded-lg shadow-xl hover:bg-red-500 hover:shadow-2xl 
                     transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-4 focus:ring-red-500 focus:ring-offset-2 mt-12"
        >
          {t('scan_prompt.scan_now')}
          <ArrowRight className="ml-4 h-7 w-7 animate-pulse" />
        </Link>
      </div>
    </div>
  );
}
